import { DEFAULT_CURRENCY, formatPrice } from './format-price.js';

/**
 * @param {unknown[]} raw
 */
function mapItems(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((x) => typeof x === 'object' && x !== null)
    .map((i) => {
      const row = /** @type {Record<string, unknown>} */ (i);
      return {
        name: typeof row.name === 'string' ? row.name : '',
        description: typeof row.description === 'string' ? row.description : undefined,
        price: typeof row.price === 'number' ? row.price : 0,
        currency: typeof row.currency === 'string' ? row.currency : DEFAULT_CURRENCY,
        imageUrl: typeof row.imageUrl === 'string' ? row.imageUrl : undefined,
      };
    });
}

/**
 * @param {HTMLElement} rootEl
 * @param {Record<string, unknown>} config
 * @param {unknown[]} feedItems
 */
export function renderFoodMenuListVertical(rootEl, config, feedItems = []) {
  const themeColor = typeof config.themeColor === 'string' ? config.themeColor : '#c0392b';
  const title = typeof config.title === 'string' ? config.title : '';
  const subtitle = typeof config.subtitle === 'string' ? config.subtitle : undefined;
  const logoUrl = typeof config.logoUrl === 'string' ? config.logoUrl : undefined;
  const backgroundUrl = typeof config.backgroundUrl === 'string' ? config.backgroundUrl : undefined;
  const configItems = Array.isArray(config.items) ? config.items : [];
  const items = feedItems.length > 0 ? mapItems(feedItems) : mapItems(configItems);

  const wrap = document.createElement('div');
  wrap.className = 'tpl-menu-list-vertical';
  if (backgroundUrl) {
    wrap.style.backgroundImage = `url(${backgroundUrl})`;
    wrap.style.backgroundSize = 'cover';
  } else {
    wrap.style.backgroundColor = '#fff';
  }

  const header = document.createElement('header');
  header.className = 'tpl-menu-list-vertical__header';
  header.style.backgroundColor = themeColor;
  if (logoUrl) {
    const logo = document.createElement('img');
    logo.src = logoUrl;
    logo.alt = '';
    logo.className = 'tpl-menu-list-vertical__logo';
    header.appendChild(logo);
  }
  const h1 = document.createElement('h1');
  h1.className = 'tpl-menu-list-vertical__title';
  h1.textContent = title;
  header.appendChild(h1);
  if (subtitle) {
    const sub = document.createElement('p');
    sub.className = 'tpl-menu-list-vertical__subtitle';
    sub.textContent = subtitle;
    header.appendChild(sub);
  }
  wrap.appendChild(header);

  const list = document.createElement('ul');
  list.className = 'tpl-menu-list-vertical__list';
  for (const item of items) {
    const li = document.createElement('li');
    li.className = 'tpl-menu-list-vertical__item';
    const row = document.createElement('div');
    row.className = 'tpl-menu-list-vertical__row';
    if (item.imageUrl) {
      const img = document.createElement('img');
      img.src = item.imageUrl;
      img.alt = '';
      img.className = 'tpl-menu-list-vertical__thumb';
      row.appendChild(img);
    }
    const body = document.createElement('div');
    body.className = 'tpl-menu-list-vertical__body';
    const top = document.createElement('div');
    top.className = 'tpl-menu-list-vertical__line';
    const name = document.createElement('span');
    name.className = 'tpl-menu-list-vertical__name';
    name.textContent = item.name;
    const price = document.createElement('span');
    price.className = 'tpl-menu-list-vertical__price';
    price.style.color = themeColor;
    price.textContent = formatPrice(item.price, item.currency);
    top.append(name, price);
    body.appendChild(top);
    if (item.description) {
      const desc = document.createElement('p');
      desc.className = 'tpl-menu-list-vertical__desc';
      desc.textContent = item.description;
      body.appendChild(desc);
    }
    row.appendChild(body);
    li.appendChild(row);
    list.appendChild(li);
  }
  wrap.appendChild(list);
  rootEl.appendChild(wrap);
}
